export default {
  REQUEST_WISHLIST_SUCCESS: 'WISHLIST / REQUEST WISHLIST / SUCCESS',
  REQUEST_WISHLIST_FAILURE: 'WISHLIST / REQUEST WISHLIST / FAILURE',
  RESET_ERROR_MESSAGE: 'WISHLIST / RESET / ERROR / MESSAGE',
  SET_IS_FETCHING: 'WISHLIST / SET / IS / FETCHING',
} as const;
